import {regions} from '../../data/regions';

export function generateCsv(localDb, delimiter) {
  if(!delimiter){
    delimiter='\t'
  }
  let headerArr = [
    'Channel Account Name',
    'SKU',
    'ASIN',
    'Repricing ON',
    'Acquisition Cost',
    'Total Minimum',
    'Total Maximum'
  ];

  headerArr = headerArr.join(delimiter);
  let productArr = [];
  regions.map((region) => {
    return localDb.map((product, index) => {
      //products without cost price will be priced incorrectly. Products without asin will invalidate Profit Protector upload
      if (product.costPrice <= 0 || !Boolean(product.asin) || !product.approved || region.toLowerCase() === 'pl' || product.exclude) { //pl is not supported by Alpha Repricer
        return;
      }
      const arr = [
        '\n',
        `merchoid${region.toUpperCase()}`,
        delimiter,
        product.id,
        delimiter,
        product.asin,
        delimiter,
        'true',
        delimiter,
        parseFloat(product.costPrice).toFixed(2),
        delimiter,
        parseFloat(product[region].minPrice).toFixed(2),
        delimiter,
        parseFloat(product[region].maxPrice).toFixed(2),
        delimiter,
      ];

      productArr.push(arr.join(''));
    });
  });
  productArr = productArr.join('');
  const fullArr = headerArr + productArr;

  console.log(headerArr, productArr);
  return fullArr;
}
